import { Arg, Metadata } from '../../../../../utils/spds/metadata';
import FlexRow from '../../../layout/flex/row.gjs';
import Super from '../../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Description text for announcement media modal.',
  meta: {
    description: Arg.string({ description: 'Description text' }).required(),
  },
  name: 'Description',
});

export default class SpdsModalAnnouncementMediaDescription extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-announcement-media-description';

  <template>
    <FlexRow
      @tag="p"
      class={{this.classes}}
      data-test-spds-modal-announcement-media-description
      {{this.validateArguments}}
      ...attributes
    >
      {{@description}}
    </FlexRow>
  </template>
}

export const MODAL_ANNOUNCEMENT_MEDIA_DESCRIPTION_METADATA =
  SpdsModalAnnouncementMediaDescription.metadata;
